import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SiteLayoutComponent , AuthGuardService as AuthGuard} from '@edgelinc/ui-library';
import { ListViewComponent } from './list-view/list-view.component';

const routes: Routes = [
    {
        path: 'views',
        component: SiteLayoutComponent,
        children: [
            { path: 'consumption-profile/list', component: ListViewComponent, canActivate: [AuthGuard]}
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class ConsumptionProfileRoutingModule {}
